import { ClockIcon } from '@heroicons/react/24/outline';
import { cn } from '@workspace/utils';

export const HORAIRES_RECONTACT_TEXT = 'Vous êtes recontacté du lundi au vendredi de 9h à 19h, et le samedi de 10h à 14h.';

interface HorairesRecontactProps {
    className?: string;
}

/**
 * Bloc vert rappelant les horaires de recontact téléphonique.
 * Affiché au-dessus du consentement téléphonique (étape coordonnées et fenêtre de rappel).
 */
export function HorairesRecontact({ className }: HorairesRecontactProps) {
    return (
        <div className={cn('flex items-center gap-3 rounded-xl bg-success-50 px-4 py-3 text-sm font-medium text-success-900 w-full text-left', className)}>
            <ClockIcon
                className="w-5 h-5 shrink-0"
                aria-hidden="true"
            />
            <p>{HORAIRES_RECONTACT_TEXT}</p>
        </div>
    );
}
